import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { useUserProfile } from '@/hooks/useUserProfile'
import { Skeleton } from '@/components/ui/skeleton'
import { MemberProfileForm } from '../components/MemberProfileForm'

export function DashboardProfilePage() {
  const { user, loading: authLoading } = useAuth()
  const { profile, loading: profileLoading } = useUserProfile()

  if (authLoading || profileLoading) {
    return (
      <div className="container mx-auto max-w-3xl px-4 py-12 space-y-6">
        <Skeleton className="h-9 w-48" />
        <Skeleton className="h-64 w-full" />
      </div>
    )
  }

  if (!user) return <Navigate to="/sign-in" replace />
  if (!profile?.linkedMemberId) return <Navigate to="/dashboard" replace />

  return (
    <div className="container mx-auto max-w-3xl px-4 py-12 space-y-8">
      <div>
        <h1 className="text-3xl font-bold">My Profile</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          This information appears on your public company page.
        </p>
      </div>
      <MemberProfileForm memberId={profile.linkedMemberId} />
    </div>
  )
}
